import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "highlight",
	standalone: false
})
export class HighlightSearch implements PipeTransform {
	public constructor(private sanitizer: DomSanitizer) {}

	public transform(value: string, args: string): SafeHtml | string {
		if (!args || args === ".") {
			// Single dot can break the regex when converted
			return value;
		}

		args = args.replace(".", "\\."); // Replace all dots to prevent using them as metacharacters
		const re = new RegExp(args, "gi"); // Create case insensitive regex
		const match = value.match(re);

		if (!match) {
			// If there's no match, just return the original value.
			return value;
		}

		const replacedValue = value.replace(re, "<b class='color-black'>" + match[0] + "</b>");
		return this.sanitizer.bypassSecurityTrustHtml(replacedValue);
	}
}
